module.exports = require("././angular-translate-storage-cookie.js");


//////////////////
// WEBPACK FOOTER
// angular-translate-storage-cookie (bower component)
// module id = 1439
// module chunks = 1